import React, { useEffect, useState } from 'react'
import './index.scss'
import { getDSPLink } from '@App/helpers/get-dsp-link'
import PointPreloader from '@App/kit/components/Preloaders/PointPreloader'
import { getDspRecordingDetails } from '@App/api/routes/recording'
import DspDataSection from './DspDataSection'
import WritersSection from './WritersSection'
import RecordingDataSection from './RecordingDataSection'
import ReleaseDataSection from './ReleaseDataSection'
import { LegacyRecording } from '@Entities/matching/recording-group-details'
import { useParams } from 'react-router'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { PARAM } from '@App/navigation/param'

const RecordingDetails = () => {
    const params = useParams<typeof PARAM>()
    const [recordingData, setRecordingData] = useState<LegacyRecording>()
    const [dspLink, setDspLink] = useState<string>()

    const getRecordingDetails = async (recordingId: string) => {
        const ApiRecordingData = await getDspRecordingDetails(recordingId)
        return ApiRecordingData.data
    }
    const initializeRecordingDetails = () => {
        const recordingId = params.recordingId
        if (recordingId) {
            getRecordingDetails(recordingId).then((ApiRecordingData) => setRecordingData(ApiRecordingData))
        }
    }

    const initializeDspLink = () => {
        if (recordingData) {
            setDspLink(getDSPLink(recordingData.dspMNumber, recordingData.dspReleaseId, recordingData.senderResourceId))
        }
    }

    useEffect(() => {
        analyticsSendPage('recording_details')
        initializeRecordingDetails()
    }, [])

    useEffect(() => {
        initializeDspLink()
    }, [recordingData])

    if (!recordingData) {
        return (
            <div className="loader-container">
                <PointPreloader />
            </div>
        )
    }

    return (
        <div className="global-container">
            <main className="recording-details-scene">
                <h3>{recordingData.recordingTitle}</h3>
                <p>
                    All recording data featured below has been provided to The MLC by the digital service provider (DSP)
                    listed. The MLC does not have the ability to edit or change any of the information provided and does
                    not assume responsibility for accuracy.
                </p>
                <RecordingDataSection recordingData={recordingData} />
                <WritersSection writers={recordingData.writers} />
                <DspDataSection recordingData={recordingData} dspLink={dspLink} />
                <ReleaseDataSection recordingData={recordingData} />
            </main>
        </div>
    )
}

export default RecordingDetails
